<div class="sd-headline sd-headline--size-lg">{{ headlineI18n | transloco }}</div>

<wct-spacer />

<table class="sd-table" [attr.loading]="userInfo() ? null : true">
  @for (input of inputs; track $index) {
    <tr>
      <td class="sd-table-cell">{{ input.i18n | transloco }}</td>
      @if (userInfo()) {
        <td class="sd-table-cell">{{ userInfo()![input.key] }}</td>
      }
    </tr>
  }
</table>
